export default function getDataset(id) {
  let translation = {};
  let companies = [];
  let roles = [];
  let items = [];
  if (id) {
    const dataset = document.getElementById(id).dataset;
    if (dataset) {
      translation = JSON.parse(dataset.translation);
      companies = JSON.parse(dataset.company);
      roles = JSON.parse(dataset.role);
      items = JSON.parse(dataset.items);
    }
  }
  return {
    translation,
    companies,
    roles,
    items
  };
}
